module.exports = __webpack_public_path__ + "static/media/country_ni.25bd0f59.webp";